import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faArrowLeft,
  faBars,
  faBox,
  faChevronDoubleLeft,
  faClipboard,
  faHome,
  faKey,
  faPowerOff,
  faStickyNote,
  faTachometer,
  faTh,
  faTimes,
} from '@fortawesome/pro-regular-svg-icons';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { FeatureToggleDirective } from '@reconcept-platform/shared/app/core';
import { ButtonComponent } from '@reconcept-platform/shared/ui/standalone/button';
import { ListItemComponent } from '@reconcept-platform/shared/ui/standalone/list';
import { RcpPopoverDirective } from '@reconcept-platform/shared/ui/standalone/popover';
import { NavListContainerComponent } from './nav-list-container/nav-list-container.component';
import { NavListGroupComponent } from './nav-list-group/nav-list-group.component';
import { NavListItemComponent } from './nav-list-item/nav-list-item.component';
import { SideNavItemComponent } from './side-nav/side-nav-item/side-nav-item.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { TopNavItemOverlayComponent } from './top-nav-item-overlay/top-nav-item-overlay.component';
import { EnvironmentIndicatorComponent } from './top-nav/top-nav-item/environment-indicator/environment-indicator.component';
import { TopNavItemComponent } from './top-nav/top-nav-item/top-nav-item.component';
import { TopNavComponent } from './top-nav/top-nav.component';

const components = [
  TopNavComponent,
  SideNavComponent,
  SideNavItemComponent,
  TopNavItemComponent,
  TopNavItemOverlayComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    FeatureToggleDirective,
    ButtonComponent,
    ListItemComponent,
    NavListItemComponent,
    NavListContainerComponent,
    RcpPopoverDirective,
    TranslatePipe,
    NavListGroupComponent,
  ],
  declarations: [...components, TopNavItemOverlayComponent, EnvironmentIndicatorComponent],
  exports: [...components, TopNavItemOverlayComponent],
})
export class SharedNavigationNavModule {
  constructor() {
    const library = inject(FaIconLibrary);

    library.addIcons(
      faBars,
      faPowerOff,
      faHome,
      faArrowLeft,
      faTimes,
      faChevronDoubleLeft,
      faClipboard,
      faKey,
      faStickyNote,
      faTh,
      faTachometer,
      faBox,
      faExclamationTriangle,
    );
  }
}
